import { Component } from "react";
import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { BrowserRouter } from "react-router-dom";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Services from "@/components/Services";
import Estimator from "@/components/Estimator";
import Work from "@/components/Work";
import WhyTcb from "@/components/WhyTcb";
import Process from "@/components/Process";
import Testimonials from "@/components/Testimonials";
import QuoteForm from "@/components/QuoteForm";
import Footer from "@/components/Footer";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(err) {
    console.error("App error:", err);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-ink flex items-center justify-center px-6">
          <div className="text-center">
            <p className="font-display text-3xl uppercase text-bone">Something went wrong</p>
            <p className="text-steel mt-3">Please refresh the page, or call us for a free quote.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function SmoothScroll({ children }) {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id.length < 2) return;
      const el = document.querySelector(id);
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -72, duration: 1.2 });
      }
    };
    document.addEventListener("click", onClick);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      document.removeEventListener("click", onClick);
    };
  }, []);

  return children;
}

export default function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <SmoothScroll>
          <div className="grain bg-ink min-h-screen">
            <Nav />
            <main>
              <Hero />
              <Marquee />
              <Services />
              <Manifesto />
              <Work />
              <Estimator />
              <Process />
              <WhyTcb />
              <Testimonials />
              <QuoteForm />
            </main>
            <Footer />
          </div>
        </SmoothScroll>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
